export default __webpack_public_path__ + "static/media/Savant's Boots of the Effulgent Blade.57d87f26.jpg";